import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// La gestión se reduce a tres apartados, a los que se entra desde la portada
// (AdminHome). Ya no hay barra lateral: cada apartado ofrece un enlace para
// volver a la portada.
//
// Los demás apartados (panel, empleados, vacaciones, cursos, contratos y
// configuración) siguen existiendo en el código y en sus rutas, pero no se
// muestran mientras el alcance esté reducido.
export default function AdminLayout() {
  const { pathname } = useLocation();
  const enPortada = pathname.replace(/\/$/, '') === '/gestion';
  return (
    <main className="admin-content admin-content--full">
      {!enPortada && (
        <Link to="/gestion" className="btn btn--ghost btn--sm" style={{ marginBottom: 16 }}>
          <ArrowLeft size={16} /> Gestión
        </Link>
      )}
      <Outlet />
    </main>
  );
}
